import React, { useMemo } from 'react';
import { Box, Paper } from '@esgian/esgianui';
import moment from 'moment/moment';

const getCircle = (percentage) => {
  return (
    <div
      key={`${percentage}-event`}
      style={{
        left: `${percentage}%`,
        position: 'absolute',
        height: '2em',
        width: '2em',
        borderRadius: '50%',
        background: 'blue',
        textAlign: 'center',
        placeContent: 'center',
        display: 'flex',
        alignItems: 'center'
      }}>
      <span style={{ fontSize: '10px' }}>{percentage}%</span>
    </div>
  );
};

function TestPage(props) {
  const startDate = moment('2024-01-01').valueOf();
  const endDate = moment('2024-12-31').valueOf();

  const data = [{ date: '2024-02-15' }, { date: '2024-07-02' }, { date: '2024-11-10' }];

  const dataWithPercentage = useMemo(() => {
    return data.map((item) => {
      const totalRange = endDate - startDate;
      const dateValue = moment(item.date).valueOf();
      const percentage = ((dateValue - startDate) / totalRange) * 100;
      return {
        ...item,
        percentage: parseInt(percentage) // Add percentage to each item, formatted to 2 decimals
      };
    });
  }, [data, startDate, endDate]);

  return (
    <Paper sx={{ p: 2, width: '100%' }}>
      <Box sx={{ width: '100%', height: '2em', background: 'red' }}>
        {dataWithPercentage.map(({ percentage }) => getCircle(percentage))}
      </Box>
    </Paper>
  );
}

TestPage.propTypes = {};

TestPage.defaultProps = {};

export default TestPage;
